var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[_vm._v("\n  "+_vm._s(_vm.abs)+"%\n\n  "),_c('PercentArrow',{staticClass:"percent__arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }